import * as React from "react";

import { ObservableValue } from "azure-devops-ui/Core/Observable";
import { Observer } from "azure-devops-ui/Observer";
import { Tab, TabBar, TabSize } from "azure-devops-ui/Tabs";

export default class SimpleTabBarExample extends React.Component<{}> {
    private selectedTabId: ObservableValue<string>;

    constructor(props: {}) {
        super(props);
        this.selectedTabId = new ObservableValue("tab2");
    }

    public render() {
        return (
            <div className="flex-column">
                <TabBar
                    onSelectedTabChanged={this.onSelectedTabChanged}
                    selectedTabId={this.selectedTabId}
                    tabSize={TabSize.Tall}
                >
                    <Tab name="Tab 1" id="tab1" />
                    <Tab name="Tab 2" id="tab2" />
                    <Tab name="Tab 3" id="tab3" />
                </TabBar>
                <Observer selectedTabId={this.selectedTabId}>
                    {(props: { selectedTabId: string }) => {
                        return <span>{"Content of " + props.selectedTabId}</span>;
                    }}
                </Observer>
            </div>
        );
    }

    private onSelectedTabChanged = (newTabId: string) => {
        this.selectedTabId.value = newTabId;
    };
}
